import { render } from "./BugTrackerMain.vue?vue&type=template&id=812dfea6&scoped=true"
import script from "./BugTrackerMain.vue?vue&type=script&lang=js"
export * from "./BugTrackerMain.vue?vue&type=script&lang=js"

import "./BugTrackerMain.vue?vue&type=style&index=0&id=812dfea6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-812dfea6"]])

export default __exports__